import { AppWindow } from '@app/entities/app-window';

declare const window: AppWindow;

export function isActiveMobileInterface(): boolean {
  if (typeof window === 'undefined') return false;
  return (window.app !== undefined || window.appInterface !== undefined || window.webkit !== undefined);
}
